module.exports = __webpack_public_path__ + "static/media/study 211214.eb89f68f.png";